import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useContext, useEffect, useState } from 'react';

import { IMachineLearningExperiment } from '../../Common/MachineLearningModels/IMachineLearningExperiment';

export function useMachineLearningExperiment(experimentId: string) {
  const [experiment, setExperiment] = useState<IMachineLearningExperiment>(null); // [IExperiment
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    httpClient
      .request<IMachineLearningExperiment>({
        url: `${__API_BASE_URL__}/machine-learning/experiments/${experimentId}`,
        resource: __CLIENT_ID__,
      })
      .then(({ data }) => {
        setExperiment(data);
      });
  }, []);

  return experiment;
}
